import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  blueIcon: {
    color: `${theme.color.blueLight} !important`,
  },
  informations: {
    "& .about": {
      display: "flex",
      "& .left, & .right": {
        width: "50%",
      },
      "& .left": {
        borderRight: `solid 1px ${theme.color.gray2}`,
        paddingRight: "10px",
      },
      "& .right": {
        marginLeft: "10px",
      },
      "& table": {
        width: "100%",
        borderSpacing: "0 20px",
      },
      "& .label": {
        color: theme.color.black,
        width: "50%",
        verticalAlign: "top",
      },
      "& .data": {
        color: theme.color.blue,
        fontWeight: "bold",
        width: "50%",
        verticalAlign: "top",
      },
    },
  },
  informationsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  informationsTitle: {
    margin: "0 !important",
    fontWeight: "bold",
  },
  divider: {
    margin: "15px 0 !important",
    display: "block",
  },
  sameLineInfo: {
    display: "flex",
    alignItems: "baseline",
    width: "fit-content !important",
  },
  disabled: {
    color: `${theme.color.gray3} !important`,
  },
}));
